import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import AriaModal from 'react-aria-modal'
import { Icon } from 'loyal-react'
import { CardBrands } from 'Catalog/Product/ProductDetail/RedemptionSection/Payment/CardBrands'
import { connect } from 'react-redux'
import PaymentClient from 'features/Checkout/Payment/PaymentBrands/PaymentClient'
import Currency from './Currency'
import { numberToStrCurrency } from 'Shared/CurrencyLabel/CurrencyLabel'

class InstallmentsWrapper extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: false,
      listInstallments: []
    }
  }
  getInstallments = async () => {
    let price = this.convertNumber(this.props.currentPrice)
    let data = {
      zip_code: '',
      shipment_id: 0,
      cart_total_value: price,
      payment_options: [2],
      products: [{
        quantity: 1,
        product_id: await PaymentClient.getOriginalId(this.props.sku)
      }]
    }
    return PaymentClient.handleInstallments(this.props.vendorId, data)
  }
  convertNumber = (num) => {
    let convertido = num.toFixed(2)
    return Number(convertido)
  }
  padLeft = (nr, n, str) => {
    return Array(n - String(nr).length + 1).join(str || '0') + nr
  }
  convertMoney = (value) => {
    return numberToStrCurrency(value, 2)
  }
  showModalInstallments = () => {
    this.setState({ showModal: !this.state.showModal })
  }
  listInstallments () {
    const listInstallments = this.getInstallments()
    return listInstallments
  }
  async componentDidMount () {
    if (this.props.isOnlyCash && this.props.showInstallments && this.state.listInstallments.length < 1) {
      const listInstallments = await this.listInstallments()
      this.setState({ listInstallments: listInstallments && listInstallments.data })
    }
  }

  getMaxPrice = () => {
    const listInstallments = this.state.listInstallments
    if (listInstallments && listInstallments.length > 0) {
      const lastInstallment = listInstallments[listInstallments.length - 1]
      const parcelas = {
        quantidadeParcelas: lastInstallment.quantidadeParcelas,
        valorParcela: lastInstallment.valorParcela,
        valorTotal: lastInstallment.valorTotal
      }
      return parcelas
    }
  }

  getInstallmentName (installment) {
    const installmentName = installment.indexOf('vista') > -1 ? 'À vista'
      : installment.indexOf('sem juros') > -1 ? 'Sem juros' : 'Com juros'

    return installmentName
  }

  getCashBackRule = (rule, value) => {
    const cashBackRule = rule === '1' ? Math.floor(0.05 * value) : Math.round(value)

    return cashBackRule
  }

  render () {
    const { Cardbrands, currency, hasCashBack, ruleCashBack, showInstallments, hideAllInstallments, hideIcon, isOnlyCash } = this.props
    const listInstallments = this.state.listInstallments
    const maxPrice = this.getMaxPrice()

    let hasInstallments = isOnlyCash && showInstallments && (this.state.listInstallments && this.state.listInstallments.length > 0)
    return hasInstallments ? (
      <Fragment>
        <div className='box-installments col-12 txt-body-sm txt-font-body txt-left color-ui-1'>
          <div className='row'>
            { !hideIcon && <div className='col-auto px-0 d-none d-lg-block'>
              <i className='icon_installments icon-sm icon icon_card' />
            </div> }
            <div className='col-auto txt-body-sm'>
              {`Ou R$ ${this.convertMoney(maxPrice.valorTotal)} em ${maxPrice.quantidadeParcelas}x de R$ ${this.convertMoney(maxPrice.valorParcela)}`}
            </div>
            { !hideAllInstallments && <div className='col-12 py-1'>
              <a role='button' onClick={this.showModalInstallments} className='cursor color-links border-color-links txt-body-sm'>Veja mais opções de parcelamento</a>
            </div> }
          </div>
        </div>
        {
          this.state.showModal && <AriaModal
            titleText='Opções de parcelamento'
            onExit={this.showModalInstallments}
            focusDialog='true'
            underlayStyle={{ zIndex: 9999 }}
          >
            <div className='modal-installments py-0 radius' data-campaign={process.env.REACT_APP_CATALOG_ID}>
              <div className='box-installments-options container py-3 px-1 px-md-3'>
                <div className='row align-items-center'>
                  <div className='col'>
                    <h1 className='txt-uppercase h2 mt-1'>Opções de parcelamento</h1>
                  </div>
                  <div className='col-auto'>
                    <a role='button'
                      href='javascript:void(0)'
                      aria-label='Fechar'
                      onClick={this.showModalInstallments} className='txt-subtitle txt-font-body d-block'>
                      <Icon
                        iconName='icon_close'
                        className='color-ui-1 cursor icon-md'
                      />
                    </a>
                  </div>
                  <div className='col-12 mt-2'>
                    <div className='row align-items-center'>
                      <div className='col-12 col-md'>
                        <div className='row align-items-center pt-2'>
                          <div className='col-auto d-none d-lg-block'>
                            <Icon
                              iconName='icon_card'
                              className='color-ui-1 icon_installments icon '
                            />
                          </div>
                          <div className='col-auto txt-body-sm'>
                            <p className='txt-uppercase txt-body-lg txt-bold mt-1'>Cartão de crédito</p>
                          </div>
                        </div>
                      </div>
                      <div className='CardBrands col-12 col-md-auto'>
                        <CardBrands {...Cardbrands} />
                      </div>
                    </div>
                  </div>
                  <div className='box-options-scroll panel-accordion col-12'>
                    <div className='panel-scroll'>
                      <div className='col-12 mt-2 border-top border-color-ui-3'>
                        {listInstallments.map((installment, index) => {
                          const installmentName = installment.nome && installment.nome.toLowerCase()
                          return (
                            <div key={index} className='installment-item row py-half'>
                              <div className='col-12'>
                                <div className='row'>
                                  <div className='col-auto'>
                                    <p className='txt-body-sm txt-font-body txt-left txt-md-center txt-bold'>
                                      {
                                        this.padLeft(installment.quantidadeParcelas, 2, '0')
                                      }
                                      x
                                    </p>
                                  </div>
                                  <div className='col-auto col-md'>
                                    <p className='txt-body-sm txt-font-body txt-left'>de R$ {this.convertMoney(installment.valorParcela)}</p>
                                  </div>
                                  <div className='col col-md'>
                                    <p className='txt-body-sm txt-font-body txt-left'>
                                      {this.getInstallmentName(installmentName)}
                                    </p>
                                  </div>
                                  { hasCashBack && <div className='col-12 col-md-auto ml-auto'>
                                    <p className='txt-body-sm txt-font-body txt-left txt-bold color-success'>
                                      <span><Currency value={this.getCashBackRule(ruleCashBack, installment.valorTotal)} {...currency} /> de volta</span>
                                    </p>
                                  </div> }
                                </div>
                              </div>
                            </div>
                          )
                        })}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </AriaModal>
        }
      </Fragment>
    ) : ''
  }
}

InstallmentsWrapper.propTypes = {
  showInstallments: PropTypes.bool,
  hideAllInstallments: PropTypes.bool,
  hideIcon: PropTypes.bool,
  currentPrice: PropTypes.number,
  isLoading: PropTypes.bool,
  brands: PropTypes.array,
  getCardBrands: PropTypes.func,
  Cardbrands: PropTypes.object,
  sku: PropTypes.string,
  vendorId: PropTypes.string,
  hasCashBack: PropTypes.bool,
  ruleCashBack: PropTypes.string,
  currency: PropTypes.shape({
    decimalPlaces: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired,
  isOnlyCash: PropTypes.bool
}

const mapStateToProps = ({ payment, onlyCash: isOnlyCash }) => {
  const { isLoading, brands } = payment
  const Cardbrands = { isLoading, brands }
  return ({
    Cardbrands,
    isOnlyCash
  })
}

export default connect(mapStateToProps)(InstallmentsWrapper)



// WEBPACK FOOTER //
// ./src/Catalog/Availability/PriceLabel/InstallmentsWrapper.js